import styles from './FilterModeToggle.module.css';
import cn from 'classnames';
import { Button } from '@round/creatorbase-ui';
import { DEFAULT_OPERATOR, Operator } from '@round/api';

type FilterModeToggleProps = {
    mode?: Operator;
    onModeChange: (mode: Operator) => void;
};

export function FilterModeToggle({ mode = DEFAULT_OPERATOR, onModeChange }: FilterModeToggleProps) {
    return (
        <div className={styles.container}>
            <Button
                variant="ghost"
                onClick={() => onModeChange('OR')}
                className={cn(styles.button, { [styles.buttonActive]: mode === 'OR' })}
            >
                OR
            </Button>
            <Button
                variant="ghost"
                onClick={() => onModeChange('AND')}
                className={cn(styles.button, { [styles.buttonActive]: mode === 'AND' })}
            >
                AND
            </Button>
        </div>
    );
}
